"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utility_1 = require("./../utils/utility");
var GoogleLoginProvider = /** @class */ (function (_super) {
    __extends(GoogleLoginProvider, _super);
    function GoogleLoginProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleLoginProvider.signIn = function (client_id, opt) {
        if (opt === void 0) { opt = { scope: 'email' }; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        utility_1.Utility.googleInitialize(_this.PROVIDER_ID, client_id).then(function (auth2) {
                            _this.oAuthGoogle = auth2;
                            var promise = auth2.signIn(opt);
                            promise.then(function (response) {
                                var profile = auth2.currentUser.get().getBasicProfile();
                                var token = auth2.currentUser.get().getAuthResponse(true).access_token;
                                var backendToken = auth2.currentUser.get().getAuthResponse(true).id_token;
                                var user = {
                                    id: profile.getId(),
                                    name: profile.getName() || null,
                                    email: profile.getEmail() || null,
                                    photoUrl: profile.getImageUrl() || null,
                                    firstName: profile.getGivenName() || null,
                                    lastName: profile.getFamilyName() || null,
                                    authToken: token,
                                    provider: _this.PROVIDER_ID,
                                    idToken: backendToken,
                                    authorizationCode: (response && response.code) ? response.code : ""
                                };
                                resolve(user);
                            }, function (closed) {
                                reject('User cancelled login or did not fully authorize.');
                            }).catch(function (err) {
                                reject(err);
                            });
                        }).catch(function (err) {
                            reject(err);
                        });
                    })];
            });
        });
    };
    GoogleLoginProvider.getLoginStatus = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.oAuthGoogle.isSignedIn.get()) {
                var profile = _this.oAuthGoogle.currentUser.get().getBasicProfile();
                var token = _this.oAuthGoogle.currentUser.get().getAuthResponse(true).access_token;
                var backendToken = _this.oAuthGoogle.currentUser.get().getAuthResponse(true).id_token;
                var user = {
                    id: profile.getId(),
                    name: profile.getName() || null,
                    email: profile.getEmail() || null,
                    photoUrl: profile.getImageUrl() || null,
                    firstName: profile.getGivenName() || null,
                    lastName: profile.getFamilyName() || null,
                    authToken: token,
                    idToken: backendToken,
                };
                resolve(user);
            }
            else {
                reject('No user is currently logged in.');
            }
        });
    };
    GoogleLoginProvider.signOut = function (revoke) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var signOutPromise;
            if (revoke) {
                signOutPromise = _this.oAuthGoogle.disconnect();
            }
            else {
                signOutPromise = _this.oAuthGoogle.signOut();
            }
            signOutPromise.then(function (err) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve();
                }
            }).catch(function (err) {
                reject(err);
            });
        });
    };
    GoogleLoginProvider.PROVIDER_ID = 'GOOGLE';
    return GoogleLoginProvider;
}(utility_1.Utility));
exports.GoogleLoginProvider = GoogleLoginProvider;
//# sourceMappingURL=google.provider.js.map